var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M3.955.545h4.09a3.41 3.41 0 0 1 3.405 3.223l.005.187v4.09a3.41 3.41 0 0 1-3.223 3.405l-.187.005h-4.09A3.41 3.41 0 0 1 .55 8.232l-.006-.187v-4.09A3.41 3.41 0 0 1 3.768.55l.187-.006h4.09zm4.09 1.023h-4.09a2.39 2.39 0 0 0-2.381 2.223l-.006.164v4.09a2.39 2.39 0 0 0 2.223 2.381l.164.006h4.09a2.39 2.39 0 0 0 2.381-2.223l.006-.164v-4.09a2.389 2.389 0 0 0-2.387-2.387zM6 3.273a2.727 2.727 0 1 1 0 5.455 2.727 2.727 0 0 1 0-5.455zm0 1.022c-.94 0-1.705.765-1.705 1.705 0 .94.765 1.705 1.705 1.705.94 0 1.705-.765 1.705-1.705 0-.94-.765-1.705-1.705-1.705zm2.932-1.59a.363.363 0 1 1 0 .727.363.363 0 0 1 0-.727z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.546094e2.svg";
export { ForwardRef as ReactComponent };